import script from "./TaskTabHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskTabHeader.vue?vue&type=script&setup=true&lang=js"

import "./TaskTabHeader.vue?vue&type=style&index=0&id=5413446d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5413446d"]])

export default __exports__